/*
  !IMPORTANT!: This file will be deleted in the future!
  If you want to use this functionality, please rather turn your *.vue file into a composition API and directly use the `useEntity` composable instead.
  This file is only kept for backwards compatibility for old *.vue files that are still using options API and mixins.

  If you want to change the branding functionality, please do it in this mixin AND the composable!
*/
import { User, Channel } from 'src/store/models/index.js'
import { Bookable, Subject, Lesson, Grade, Teacher } from 'src/store/models/timetable/index.js'
import { ENTITY_TYPE } from 'src/config/constants.ts'
import Classbooks from 'src/api/classbooks.js'

const entityData = [
  {
    entity: null,
    type: 'fallback',
    icon: 'icon-close-o',
    color: 'grey',
    label: 'timetable.components.choose_entity.entities.undefined',
    title: 'meta.displayname'
  },
  {
    entity: User,
    type: 'student',
    icon: 'icon-user-child',
    color: 'type-student',
    label: 'timetable.components.choose_entity.entities.student.singular',
    title: 'meta.displayname'
  },
  {
    entity: User,
    type: 'teacher',
    icon: 'icon-user-teacher',
    color: 'type-teacher',
    label: 'timetable.components.choose_entity.entities.teacher.singular',
    title: 'meta.displayname'
  },
  {
    entity: Teacher,
    type: 'teacher',
    icon: 'icon-user-teacher',
    color: 'type-teacher',
    label: 'timetable.components.choose_entity.entities.teacher.singular',
    title: 'meta.displayname'
  },
  {
    entity: User,
    type: 'parent',
    icon: 'icon-user-parent',
    color: 'type-parent',
    label: 'timetable.components.choose_entity.entities.parent.singular',
    title: 'meta.displayname'
  },
  {
    entity: Grade,
    type: 'grade',
    icon: 'icon-class',
    color: 'type-student',
    label: 'timetable.components.choose_entity.entities.grade.singular',
    title: 'meta.displayname'
  },
  {
    entity: Lesson,
    type: 'lesson',
    icon: 'icon-bell',
    color: 'type-teacher',
    label: 'timetable.components.choose_entity.entities.teacher.general',
    title: 'shortcut'
  },
  {
    entity: Subject,
    type: 'subject',
    icon: '',
    color: 'dark',
    label: 'timetable.components.choose_entity.entities.subject.singular',
    title: 'shortcut'
  },
  {
    entity: Bookable,
    type: 'bookable',
    icon: 'icon-key',
    color: 'purple',
    label: 'timetable.components.choose_entity.entities.bookable.singular',
    title: 'shortcut'
  },
  {
    entity: Channel,
    icon: 'icon-channel-parents-56',
    color: 'type-parent',
    target: 'parents'
  },
  {
    entity: Channel,
    icon: 'icon-channel-parents-56',
    color: 'type-parent',
    target: 'teachers-parents'
  },
  {
    entity: Channel,
    icon: 'icon-channel-students-56',
    color: 'type-student',
    target: 'students'
  },
  {
    entity: Channel,
    icon: 'icon-channel-custom-and-teachers-56',
    color: 'type-teacher',
    target: 'teachers'
  },
  {
    entity: Channel,
    icon: 'icon-channel-custom-and-teachers-56',
    color: 'gray-300',
    target: 'global'
  },
  {
    entity: Channel,
    icon: 'icon-channel-custom-and-teachers-56',
    color: 'gray-300',
    target: 'sv'
  },
  {
    entity: Channel,
    icon: 'icon-channel-custom-and-teachers-56',
    color: 'gray-300',
    target: 'sekretariat'
  },
  {
    entity: Channel,
    icon: 'icon-channel-custom-and-teachers-56',
    color: 'gray-300',
    type: 'custom'
  },
  {
    entity: Channel,
    target: 'courses',
    color: 'gray-300',
    type: 'custom'
  },
  {
    entity: Channel,
    target: 'course-parents',
    color: 'gray-300',
    type: 'custom'
  },
  {
    entity: Channel,
    color: 'gray-300',
    type: 'chat'
  }
]

const entityMixin = {
  computed: {
    isSingleEntity () {
      return this.$route.params.id !== ENTITY_TYPE.allGrades &&
        this.$route.params.id !== ENTITY_TYPE.allCourses &&
        this.$route.params.id !== ENTITY_TYPE.allUsers
    }
  },
  methods: {
    userProps (user) {
      const data = this.getEntityData(new User(user))
      if (data.color.includes('sdui-icon')) return [data.icon, data.color]
      return [data.icon, data.color, `${data.color}-light-bg`]
    },
    getEntityData (entity) {
      return this.getEntityInstance(entity) || entityData[0]
    },
    getEntityInstance (entity) {
      if (!entity || !(entity instanceof Object)) {
        return null
      }

      const matchingEntity = entityData.find(el => el.entity && entity instanceof el.entity &&
        !(entity instanceof User || entity instanceof Channel))

      if (matchingEntity) return matchingEntity

      if (!(entity instanceof User || entity instanceof Channel)) {
        return null
      }

      // object because user management doesnt have orm
      if (entity.type && entity instanceof User) {
        const item = entityData.find(el => el.type === entity.type.toLowerCase())

        if (entity.expire_at) {
          const icon = `${item.icon} expired-icon`
          return { ...item, icon: icon }
        }

        if (entity.state === 'PENDING') {
          const icon = `${item.icon} pending-user`

          return {
            ...item,
            icon: icon
          }
        }

        return item
      }
      if (entity.target) {
        return entityData.find(el => el.target === entity.target.toLowerCase())
      }
      if (entity.type && entity instanceof Channel) {
        return entityData.find(el => el.type === entity.type.toLowerCase())
      }

      return null
    },

    async fetchEntity (entity, customId = null, classbookId = null) {
      const entityEndpoint = (id) => {
        if (entity === 'grades') return Classbooks.gradesByIdUrl(this.$route.params.classbook || classbookId, id || '')
        if (entity === 'courses') return Classbooks.coursesByIdUrl(this.$route.params.classbook || classbookId, id || '')
        if (entity === 'users') return Classbooks.usersByIdUrl(this.$route.params.classbook || classbookId, id || '')
      }

      // use cached result, as this doesn´t update often and update resource in background
      const { data, network } = await this.$cacheHttp(entityEndpoint(customId), { timeout: import.meta.env.VITE_CLASSBOOK_EXTENDED_REQUEST_TIMEOUT })
      network()

      return data
    }
  }
}
export default entityMixin
